<div class="no-access-wrapper">
  <div class="no-access-card">

    <div class="no-access-icon">
      <span class="pi pi-lock"></span>
    </div>

    <h1 class="no-access-title">No Access</h1>
    <p class="no-access-desc">
      Your account doesn't have any features assigned.<br />
      Please contact your administrator to get the appropriate role and permissions.
    </p>

    <div class="no-access-actions">
      <button pButton
        label="Sign Out"
        icon="pi pi-sign-out"
        severity="secondary"
        (click)="onLogout()">
      </button>
    </div>

  </div>
</div>
